"use strict";
exports.__esModule = true;
exports.rgpdLink = exports.footerLink = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var footerLink = function (data, logger) {
    var _a, _b;
    if (!data) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.FooterLinkTypes.FOOTER_LINK,
        link: logger.required(fields_1.toLink((_a = data.primary) === null || _a === void 0 ? void 0 : _a.link, logger)),
        label: logger.required(fields_1.toText((_b = data.primary) === null || _b === void 0 ? void 0 : _b.label))
    });
};
exports.footerLink = footerLink;
var rgpdLink = function (data, logger) {
    var _a;
    if (!data) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.FooterLinkTypes.RGPD_LINK,
        label: logger.required(fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.label))
    });
};
exports.rgpdLink = rgpdLink;
//# sourceMappingURL=footer-link.js.map